import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, IPageContent} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {CommonService} from '@app/feature/store-editor/services/common.service';

@Component({
  selector: 'app-testimonial-setting',
  templateUrl: './testimonial-setting.component.html',
  styleUrls: ['../styling/styling.component.css']
})
export class TestimonialSettingComponent implements OnInit {
  @Input() item: IPageContent;
  @Input() layoutSetting: ILayoutSettings;

  constructor(private cs: CommonService) {
  }

  ngOnInit() {
  }

  imageSelector(image: string) {
    if (image) {
      return image;
    } else {
      return '/assets/img/imagePlaceholder.png';
    }
  }


  addItemTestimonialInList() {
    this.item.data.list.push(
      {
        image: '',
        name: 'User',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit'
      });
  }
  removeTestimonial(selectTestimonial: number) {
    this.item.data.list.splice(selectTestimonial, 1);
  }

  selectFileToTestimonial(el: any, TestimonialIndex: number) {
    const input = el.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(input);
    reader.onload = () => {
      this.item.data.list[TestimonialIndex].image = reader.result.toString();
      this.cs.uploadFile(input.name, reader.result.toString()).then(res => this.item.data.list[TestimonialIndex].image = res);
    };
  }

}
